import { useMemo } from 'react';
import { WidgetsConfig } from '@sitecore-search/core';
const validateWidgetComponent = (Widget, entity, ContextComponent) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore it's an internal flag
    if (Widget.__wrapped === true) {
        throw new Error(`Seems you are trying to wrap an already wrapped Widget component (entity: ${entity})`);
    }
    ContextComponent.__wrapped = true;
    return ContextComponent;
};
export const buildWidgetTypeComponent = (type, Widget, entity, providersBuilder) => {
    const ContextComponent = (props) => {
        const { rfkId } = props;
        useMemo(() => {
            WidgetsConfig.setType(rfkId, type);
        }, [rfkId]);
        return providersBuilder(props, {
            rfkId,
            entity,
        }, Widget);
    };
    return validateWidgetComponent(Widget, entity, ContextComponent);
};
